// import { useEffect, useRef, useCallback } from 'react';
// import { gsap } from 'gsap';

// /**
//  * Loader — manual 4.5 s count-up, no asset dependency.
//  *
//  * Props:
//  *   onComplete – called after the count reaches 100 % AND the exit
//  *                animation finishes.
//  */
// export default function Loader({ onComplete }) {
//   const loaderRef  = useRef(null);
//   const barRef     = useRef(null);
//   const countRef   = useRef(null);
//   const gsapCtx    = useRef(null);
//   const rafId      = useRef(null);
//   const completed  = useRef(false);

//   // Always use the latest onComplete without re-running effects
//   const onCompleteRef = useRef(onComplete);
//   useEffect(() => { onCompleteRef.current = onComplete; }, [onComplete]);

//   // ── helpers ────────────────────────────────────────────────────────────────

//   const setProgress = useCallback((pct) => {
//     const clamped = Math.min(100, Math.max(0, pct));
//     if (countRef.current) countRef.current.textContent = Math.round(clamped) + '%';
//     if (barRef.current)   barRef.current.style.width   = clamped + '%';
//   }, []);

//   const runExit = useCallback(() => {
//     if (completed.current) return;
//     completed.current = true;

//     gsap.to('.loader-content', { opacity: 0, duration: 0.4 });
//     gsap.to(loaderRef.current, {
//       yPercent: -100,
//       duration: 0.8,
//       delay: 0.4,
//       ease: 'power3.inOut',
//       onComplete: () => onCompleteRef.current?.(),
//     });
//   }, []);

//   // ── main effect ────────────────────────────────────────────────────────────

//   useEffect(() => {
//     // Entrance animations
//     gsapCtx.current = gsap.context(() => {
//       gsap.fromTo('.loader-content', { opacity: 0 }, { opacity: 1, duration: 0.5 });
//       gsap.fromTo(
//         '.loader-line',
//         { y: 40, opacity: 0 },
//         { y: 0, opacity: 1, duration: 0.8, stagger: 0.15, delay: 0.2, ease: 'power3.out' }
//       );
//     });

//     // ── Manual count-up over DURATION ms with an ease curve ──────────────────
//     const DURATION = 4500; // 4.5 s total
//     const startTime = performance.now();

//     /**
//      * Ease-in-out cubic:  slow start → fast middle → slow finish.
//      * Swap for a linear or any other curve as desired.
//      */
//     function easeInOutCubic(t) {
//       return t < 0.5
//         ? 4 * t * t * t
//         : 1 - Math.pow(-2 * t + 2, 3) / 2;
//     }

//     function tick(now) {
//       const elapsed = now - startTime;
//       const rawT    = Math.min(elapsed / DURATION, 1);
//       const eased   = easeInOutCubic(rawT);

//       setProgress(eased * 100);

//       if (rawT < 1) {
//         rafId.current = requestAnimationFrame(tick);
//       } else {
//         setProgress(100);
//         runExit();
//       }
//     }

//     rafId.current = requestAnimationFrame(tick);

//     // ── Cleanup ───────────────────────────────────────────────────────────────
//     return () => {
//       cancelAnimationFrame(rafId.current);
//       gsapCtx.current?.revert();
//       gsap.killTweensOf(['.loader-content', '.loader-line', loaderRef.current]);
//     };
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []); // intentionally empty – runs once on mount

//   // ── render ─────────────────────────────────────────────────────────────────

//   return (
//     <div
//       ref={loaderRef}
//       style={{
//         position:        'fixed',
//         inset:           0,
//         background:      '#050505',
//         zIndex:          99999,
//         display:         'flex',
//         flexDirection:   'column',
//         justifyContent:  'center',
//         alignItems:      'center',
//       }}
//     >
//       <div
//         className="loader-content"
//         style={{ textAlign: 'center', width: '100%', padding: '0 3rem', maxWidth: 500 }}
//       >
//         {/* Label */}
//         <div style={{ overflow: 'hidden', marginBottom: '1rem' }}>
//           <div
//             className="loader-line"
//             style={{
//               fontFamily:    'Space Mono',
//               fontSize:      '0.7rem',
//               color:         'var(--acid)',
//               letterSpacing: '0.2em',
//               textTransform: 'uppercase',
//             }}
//           >
//             Initializing...
//           </div>
//         </div>

//         {/* Title */}
//         <div style={{ overflow: 'hidden', marginBottom: '3rem' }}>
//           <div
//             className="loader-line"
//             style={{
//               fontFamily:    'Syne',
//               fontSize:      'clamp(2.5rem, 8vw, 5rem)',
//               fontWeight:    800,
//               letterSpacing: '-0.04em',
//               color:         '#f0ece4',
//               lineHeight:    1,
//             }}
//           >
//             .DEV
//           </div>
//         </div>

//         {/* Progress bar */}
//         <div
//           style={{
//             height:     1,
//             background: '#1e1e1e',
//             marginBottom: '1rem',
//             overflow:   'hidden',
//           }}
//         >
//           <div
//             ref={barRef}
//             style={{
//               height:     '100%',
//               background: 'var(--acid)',
//               width:      '0%',
//               /* No CSS transition — rAF drives width directly for smooth easing */
//             }}
//           />
//         </div>

//         {/* Meta row */}
//         <div
//           style={{
//             display:        'flex',
//             justifyContent: 'space-between',
//             fontFamily:     'Space Mono',
//             fontSize:       '0.65rem',
//             color:          '#444',
//           }}
//         >
//           <span>Loading assets</span>
//           <span ref={countRef}>0%</span>
//         </div>
//       </div>
//     </div>
//   );
// }


// import { useEffect, useRef, useCallback } from 'react';
// import { gsap } from 'gsap';

// /**
//  * Loader — rolling-digit counter + 5 progress squares.
//  * 4.5 s count-up, no asset dependency.
//  *
//  * Props:
//  *   onComplete – called after the count reaches 100 % AND the exit
//  *                animation finishes.
//  */

// const DURATION = 4500;
// const SQUARES = 5;

// // Row height: raise it if the tops/bottoms of digits look shaved
// const ROW_H = '1.15em';   // height of each digit row (extra room so tops/bottoms aren't shaved)

// // 0-9 plus a repeated 0 so the strip can wrap seamlessly
// const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

// function easeInOutCubic(t) {
//   return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
// }

// export default function Loader({ onComplete }) {
//   const loaderRef = useRef(null);
//   const hundredsRef = useRef(null);
//   const tensRef = useRef(null);
//   const onesRef = useRef(null);
//   const squareRefs = useRef([]);
//   const gsapCtx = useRef(null);
//   const rafId = useRef(null);
//   const completed = useRef(false);

//   // Always use the latest onComplete without re-running effects
//   const onCompleteRef = useRef(onComplete);
//   useEffect(() => { onCompleteRef.current = onComplete; }, [onComplete]);

//   // ── helpers ────────────────────────────────────────────────────────────────

//   // Each strip holds 11 rows; moving by (n / 11 * 100)% shows digit n
//   const setStrip = (el, pos) => {
//     if (el) el.style.transform = `translateY(${-(pos / 11) * 100}%)`;
//   };

//   const setProgress = useCallback((pct) => {
//     const v = Math.min(100, Math.max(0, pct));

//     setStrip(onesRef.current, v % 10);
//     setStrip(tensRef.current, (v / 10) % 10);
//     // Hundreds stays at 0 until 90 %, then rolls to 1 as the tens wrap 9 -> 0
//     setStrip(hundredsRef.current, Math.max(0, v - 90) / 10);

//     // Fill squares as progress passes each 20 % step
//     squareRefs.current.forEach((sq, i) => {
//       if (!sq) return;
//       const on = v > i * (100 / SQUARES);
//       sq.style.background = on ? 'var(--acid)' : '#2a2a2a';
//       sq.style.transform = on ? 'scale(1)' : 'scale(0.85)';
//     });
//   }, []);

//   const runExit = useCallback(() => {
//     if (completed.current) return;
//     completed.current = true;

//     gsap.to('.loader-content', { opacity: 0, duration: 0.4 });
//     gsap.to(loaderRef.current, {
//       yPercent: -100,
//       duration: 0.8,
//       delay: 0.4,
//       ease: 'power3.inOut',
//       onComplete: () => onCompleteRef.current?.(),
//     });
//   }, []);

//   // ── main effect ────────────────────────────────────────────────────────────

//   useEffect(() => {
//     gsapCtx.current = gsap.context(() => {
//       gsap.fromTo('.loader-content', { opacity: 0 }, { opacity: 1, duration: 0.5 });
//     });

//     setProgress(0);
//     const startTime = performance.now();

//     function tick(now) {
//       const rawT = Math.min((now - startTime) / DURATION, 1);
//       setProgress(easeInOutCubic(rawT) * 100);

//       if (rawT < 1) {
//         rafId.current = requestAnimationFrame(tick);
//       } else {
//         setProgress(100);
//         runExit();
//       }
//     }

//     rafId.current = requestAnimationFrame(tick);

//     return () => {
//       cancelAnimationFrame(rafId.current);
//       gsapCtx.current?.revert();
//       gsap.killTweensOf(['.loader-content', loaderRef.current]);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []); // intentionally empty – runs once on mount

//   // ── render ─────────────────────────────────────────────────────────────────

//   const digitCol = (ref) => (
//     <div style={{ height: ROW_H, overflow: 'hidden', flexShrink: 0 }}>
//       <div
//         ref={ref}
//         style={{ willChange: 'transform' }}
//       >
//         {DIGITS.map((d, i) => (
//           <div
//             key={i}
//             style={{
//               height: ROW_H,
//               lineHeight: ROW_H,
//               textAlign: 'center',
//             }}
//           >
//             {d}
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <div
//       ref={loaderRef}
//       style={{
//         position: 'fixed',
//         inset: 0,
//         background: '#050505',
//         zIndex: 99999,
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//       }}
//     >
//       <div
//         className="loader-content"
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           gap: 'clamp(4rem, 12vh, 7rem)',
//         }}
//       >
//         {/* Rolling number */}
//         <div
//           style={{
//             display: 'flex',
//             fontFamily: 'Syne, sans-serif',
//             fontWeight: 800,
//             fontSize: 'clamp(5rem, 16vw, 9rem)',
//             letterSpacing: '-0.04em',
//             color: '#f0ece4',
//             height: ROW_H,
//             overflow: 'hidden',
//           }}
//         >
//           {digitCol(hundredsRef)}
//           {digitCol(tensRef)}
//           {digitCol(onesRef)}
//         </div>

//         {/* Progress squares */}
//         <div style={{ display: 'flex', gap: '3.2rem' }}>
//           {Array.from({ length: SQUARES }).map((_, i) => (
//             <div
//               key={i}
//               ref={(el) => (squareRefs.current[i] = el)}
//               style={{
//                 width: 12,
//                 height: 12,
//                 borderRadius: 2,
//                 background: '#2a2a2a',
//                 transition: 'background 0.25s ease, transform 0.25s ease',
//               }}
//             />
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }


// import { useEffect, useRef, useCallback } from 'react';
// import { gsap } from 'gsap';

// /**
//  * Loader — rolling-digit counter + 5 progress squares, then an image reveal.
//  * 4.5 s count-up -> counter fades out -> image fades in and holds ->
//  * loader slides up to reveal the landing page.
//  *
//  * Props:
//  *   onComplete – called after the count reaches 100 %, the image has been
//  *                shown, AND the exit animation finishes.
//  */

// const DURATION = 4500;
// const SQUARES = 5;

// const IMAGE_URL =
//   'https://izeiyujebczudhvsvbon.supabase.co/storage/v1/object/public/bucket/uploads/1791382062875_kxbxmxpbhsr.png';
// const IMAGE_HOLD = 2; // seconds the image stays on screen

// // Row height: raise it if the tops/bottoms of digits look shaved
// const ROW_H = '1.15em';   // height of each digit row (extra room so tops/bottoms aren't shaved)

// // 0-9 plus a repeated 0 so the strip can wrap seamlessly
// const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

// function easeInOutCubic(t) {
//   return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
// }

// export default function Loader({ onComplete }) {
//   const loaderRef = useRef(null);
//   const hundredsRef = useRef(null);
//   const tensRef = useRef(null);
//   const onesRef = useRef(null);
//   const squareRefs = useRef([]);
//   const imageRef = useRef(null);
//   const exitTl = useRef(null);
//   const gsapCtx = useRef(null);
//   const rafId = useRef(null);
//   const completed = useRef(false);

//   // Always use the latest onComplete without re-running effects
//   const onCompleteRef = useRef(onComplete);
//   useEffect(() => { onCompleteRef.current = onComplete; }, [onComplete]);

//   // ── helpers ────────────────────────────────────────────────────────────────

//   // Each strip holds 11 rows; moving by (n / 11 * 100)% shows digit n
//   const setStrip = (el, pos) => {
//     if (el) el.style.transform = `translateY(${-(pos / 11) * 100}%)`;
//   };

//   const setProgress = useCallback((pct) => {
//     const v = Math.min(100, Math.max(0, pct));

//     setStrip(onesRef.current, v % 10);
//     setStrip(tensRef.current, (v / 10) % 10);
//     // Hundreds stays at 0 until 90 %, then rolls to 1 as the tens wrap 9 -> 0
//     setStrip(hundredsRef.current, Math.max(0, v - 90) / 10);

//     // Fill squares as progress passes each 20 % step
//     squareRefs.current.forEach((sq, i) => {
//       if (!sq) return;
//       const on = v > i * (100 / SQUARES);
//       sq.style.background = on ? 'var(--acid)' : '#2a2a2a';
//       sq.style.transform = on ? 'scale(1)' : 'scale(0.85)';
//     });
//   }, []);

//   const runExit = useCallback(() => {
//     if (completed.current) return;
//     completed.current = true;

//     exitTl.current = gsap.timeline({
//       onComplete: () => onCompleteRef.current?.(),
//     });

//     exitTl.current
//       // counter + squares out
//       .to('.loader-content', { opacity: 0, duration: 0.4 })
//       // image in
//       .fromTo(
//         imageRef.current,
//         { opacity: 0, scale: 1.05 },
//         { opacity: 1, scale: 1, duration: 0.8, ease: 'power2.out' }
//       )
//       // hold
//       .to({}, { duration: IMAGE_HOLD })
//       // slide the whole loader away to reveal the landing page
//       .to(loaderRef.current, {
//         yPercent: -100,
//         duration: 0.8,
//         ease: 'power3.inOut',
//       });
//   }, []);

//   // ── main effect ────────────────────────────────────────────────────────────

//   useEffect(() => {
//     // Preload the image during the count so it doesn't pop in late
//     const img = new Image();
//     img.src = IMAGE_URL;

//     gsapCtx.current = gsap.context(() => {
//       gsap.fromTo('.loader-content', { opacity: 0 }, { opacity: 1, duration: 0.5 });
//     });

//     setProgress(0);
//     const startTime = performance.now();

//     function tick(now) {
//       const rawT = Math.min((now - startTime) / DURATION, 1);
//       setProgress(easeInOutCubic(rawT) * 100);

//       if (rawT < 1) {
//         rafId.current = requestAnimationFrame(tick);
//       } else {
//         setProgress(100);
//         runExit();
//       }
//     }

//     rafId.current = requestAnimationFrame(tick);

//     return () => {
//       cancelAnimationFrame(rafId.current);
//       exitTl.current?.kill();
//       gsapCtx.current?.revert();
//       gsap.killTweensOf(['.loader-content', loaderRef.current, imageRef.current]);
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []); // intentionally empty – runs once on mount

//   // ── render ─────────────────────────────────────────────────────────────────

//   const digitCol = (ref) => (
//     <div style={{ height: ROW_H, overflow: 'hidden', flexShrink: 0 }}>
//       <div
//         ref={ref}
//         style={{ willChange: 'transform' }}
//       >
//         {DIGITS.map((d, i) => (
//           <div
//             key={i}
//             style={{
//               height: ROW_H,
//               lineHeight: ROW_H,
//               textAlign: 'center',
//             }}
//           >
//             {d}
//           </div>
//         ))}
//       </div>
//     </div>
//   );

//   return (
//     <div
//       ref={loaderRef}
//       style={{
//         position: 'fixed',
//         inset: 0,
//         background: '#050505',
//         zIndex: 99999,
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         overflow: 'hidden',
//       }}
//     >
//       <div
//         className="loader-content"
//         style={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           gap: 'clamp(4rem, 12vh, 7rem)',
//         }}
//       >
//         {/* Rolling number */}
//         <div
//           style={{
//             display: 'flex',
//             fontFamily: 'Syne, sans-serif',
//             fontWeight: 800,
//             fontSize: 'clamp(5rem, 16vw, 9rem)',
//             letterSpacing: '-0.04em',
//             color: '#f0ece4',
//             height: ROW_H,
//             overflow: 'hidden',
//           }}
//         >
//           {digitCol(hundredsRef)}
//           {digitCol(tensRef)}
//           {digitCol(onesRef)}
//         </div>

//         {/* Progress squares */}
//         <div style={{ display: 'flex', gap: '3.2rem' }}>
//           {Array.from({ length: SQUARES }).map((_, i) => (
//             <div
//               key={i}
//               ref={(el) => (squareRefs.current[i] = el)}
//               style={{
//                 width: 12,
//                 height: 12,
//                 borderRadius: 2,
//                 background: '#2a2a2a',
//                 transition: 'background 0.25s ease, transform 0.25s ease',
//               }}
//             />
//           ))}
//         </div>
//       </div>

//       {/* Image shown after the count finishes */}
//       <img
//         ref={imageRef}
//         src={IMAGE_URL}
//         alt=""
//         style={{
//           position: 'absolute',
//           inset: 0,
//           width: '100%',
//           height: '100%',
//           objectFit: 'contain', // use 'cover' to fill the whole screen
//           opacity: 0,
//           pointerEvents: 'none',
//         }}
//       />
//     </div>
//   );
// }




import { useEffect, useRef, useCallback } from 'react';
import { gsap } from 'gsap';

/**
 * Loader — rolling-digit counter + 5 progress squares.
 * 4.5 s count-up, no asset dependency.
 *
 * Props:
 *   onComplete – called after the count reaches 100 % AND the wavy exit
 *                transition finishes.
 */

const DURATION = 4500;
const SQUARES = 5;

// Row height: raise it if the tops/bottoms of digits look shaved
const ROW_H = '1.15em';   // height of each digit row (extra room so tops/bottoms aren't shaved)

// 0-9 plus a repeated 0 so the strip can wrap seamlessly
const DIGITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

// ── Wavy exit wrapper (same effect as the Navbar transition) ─────────────────
// One SVG path (viewBox 0–100): a band with a wavy top edge (a) and a wavy
// bottom edge (b).
//   cover: bottom edge sweeps down  → screen fully covered
//   exit : top edge sweeps down     → screen revealed
const AMP = 10;  // wave height (viewBox units)
const OFF = 15;  // overshoot so the waves fully clear the screen
const N   = 40;  // points per edge

function buildPath(a, b, ph) {
  let d = '';
  for (let i = 0; i <= N; i++) {
    const x = (i / N) * 100;
    const y = a + Math.sin((x / 100) * Math.PI * 2 + ph) * AMP;
    d += `${i ? 'L' : 'M'}${x},${y} `;
  }
  for (let i = N; i >= 0; i--) {
    const x = (i / N) * 100;
    const y = b + Math.sin((x / 100) * Math.PI * 2 + ph) * AMP;
    d += `L${x},${y} `;
  }
  return d + 'Z';
}

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

export default function Loader({ onComplete }) {
  const loaderRef = useRef(null);
  const hundredsRef = useRef(null);
  const tensRef = useRef(null);
  const onesRef = useRef(null);
  const squareRefs = useRef([]);
  const pathRef = useRef(null);
  const waveState = useRef({ a: -OFF, b: -OFF, ph: 0 });
  const tlRef = useRef(null);
  const gsapCtx = useRef(null);
  const rafId = useRef(null);
  const completed = useRef(false);

  // Always use the latest onComplete without re-running effects
  const onCompleteRef = useRef(onComplete);
  useEffect(() => { onCompleteRef.current = onComplete; }, [onComplete]);

  // ── helpers ────────────────────────────────────────────────────────────────

  // Each strip holds 11 rows; moving by (n / 11 * 100)% shows digit n
  const setStrip = (el, pos) => {
    if (el) el.style.transform = `translateY(${-(pos / 11) * 100}%)`;
  };

  const setProgress = useCallback((pct) => {
    const v = Math.min(100, Math.max(0, pct));

    setStrip(onesRef.current, v % 10);
    setStrip(tensRef.current, (v / 10) % 10);
    // Hundreds stays at 0 until 90 %, then rolls to 1 as the tens wrap 9 -> 0
    setStrip(hundredsRef.current, Math.max(0, v - 90) / 10);

    // Fill squares as progress passes each 20 % step
    squareRefs.current.forEach((sq, i) => {
      if (!sq) return;
      const on = v > i * (100 / SQUARES);
      sq.style.background = on ? 'var(--acid)' : '#2a2a2a';
      sq.style.transform = on ? 'scale(1)' : 'scale(0.85)';
    });
  }, []);

  const runExit = useCallback(() => {
    if (completed.current) return;
    completed.current = true;

    const wave = waveState.current;
    const END = 100 + OFF;
    const ease = 'power3.inOut';
    const draw = () =>
      pathRef.current?.setAttribute('d', buildPath(wave.a, wave.b, wave.ph));

    const tl = gsap.timeline({
      onUpdate: draw,
      onComplete: () => onCompleteRef.current?.(),
    });
    tlRef.current = tl;

    // 1) Content fades, acid wave sweeps down and covers the black loader
    tl.to('.loader-content', { opacity: 0, duration: 0.4 }, 0);
    tl.fromTo(wave, { b: -OFF, ph: 0 }, { b: END, ph: Math.PI, duration: 0.8, ease }, 0.2);

    // 2) Fully covered → drop the black background so the page is underneath
    tl.call(() => {
      if (loaderRef.current) loaderRef.current.style.background = 'transparent';
    });

    // 3) Wave sweeps out the bottom, revealing the page
    tl.addLabel('exit', '+=0.15');
    tl.to(wave, { a: END, ph: Math.PI * 2, duration: 0.8, ease }, 'exit');
  }, []);

  // ── main effect ────────────────────────────────────────────────────────────

  useEffect(() => {
    gsapCtx.current = gsap.context(() => {
      gsap.fromTo('.loader-content', { opacity: 0 }, { opacity: 1, duration: 0.5 });
    });

    setProgress(0);
    const startTime = performance.now();

    function tick(now) {
      const rawT = Math.min((now - startTime) / DURATION, 1);
      setProgress(easeInOutCubic(rawT) * 100);

      if (rawT < 1) {
        rafId.current = requestAnimationFrame(tick);
      } else {
        setProgress(100);
        runExit();
      }
    }

    rafId.current = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(rafId.current);
      tlRef.current?.kill();
      gsapCtx.current?.revert();
      gsap.killTweensOf(['.loader-content', loaderRef.current]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // intentionally empty – runs once on mount

  // ── render ─────────────────────────────────────────────────────────────────

  const digitCol = (ref) => (
    <div style={{ height: ROW_H, overflow: 'hidden', flexShrink: 0 }}>
      <div
        ref={ref}
        style={{ willChange: 'transform' }}
      >
        {DIGITS.map((d, i) => (
          <div
            key={i}
            style={{
              height: ROW_H,
              lineHeight: ROW_H,
              textAlign: 'center',
            }}
          >
            {d}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div
      ref={loaderRef}
      style={{
        position: 'fixed',
        inset: 0,
        background: '#050505',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div
        className="loader-content"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'clamp(4rem, 12vh, 7rem)',
        }}
      >
        {/* Rolling number */}
        <div
          style={{
            display: 'flex',
            fontFamily: 'Syne, sans-serif',
            fontWeight: 800,
            fontSize: 'clamp(5rem, 16vw, 9rem)',
            letterSpacing: '-0.04em',
            color: '#f0ece4',
            height: ROW_H,
            overflow: 'hidden',
          }}
        >
          {digitCol(hundredsRef)}
          {digitCol(tensRef)}
          {digitCol(onesRef)}
        </div>

        {/* Progress squares */}
        <div style={{ display: 'flex', gap: '3.2rem' }}>
          {Array.from({ length: SQUARES }).map((_, i) => (
            <div
              key={i}
              ref={(el) => (squareRefs.current[i] = el)}
              style={{
                width: 12,
                height: 12,
                borderRadius: 2,
                background: '#2a2a2a',
                transition: 'background 0.25s ease, transform 0.25s ease',
              }}
            />
          ))}
        </div>
      </div>

      {/* Wavy exit wrapper */}
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          display: 'block',
          pointerEvents: 'none',
        }}
      >
        <path ref={pathRef} style={{ fill: 'var(--acid)' }} />
      </svg>
    </div>
  );
}